import React from 'react'
import T from 'prop-types'
import DialogContainer from '../components/DialogContainer'
import getBaseClass from './getBaseClass'

const MaximizableWrapper = WrappedComponent => {
  const BaseClass = getBaseClass(WrappedComponent)

  return class Maximizable extends BaseClass {
    static displayName = `Maximizable(${WrappedComponent.displayName || 'Component'})`

    static propTypes = {
      getRef: T.func, // TODO remove and use regular refs when React addresses the issues at the end of this https://facebook.github.io/react/docs/higher-order-components.html
      className: T.string
    }

    state = {
      maximized: false
    }

    handleToggleMaximized = () => {
      this.setState({
        maximized: !this.state.maximized
      })
    }

    render() {
      const {
        className,
        getRef
      } = this.props
      const {
        maximized
      } = this.state
      const refProps = {}
      refProps[WrappedComponent.propTypes && WrappedComponent.propTypes.getRef ? 'getRef': 'ref'] = getRef

      const _children = (
        <div className="maximizable_content">
          <WrappedComponent
            {...refProps}
            {...this.props}
            isMaximized={maximized}
          />
          <div
            className={`maximize_btn btn btn-icon icon-${maximized ? 'close' : 'zoomin'}`}
            data-tooltip={maximized ? 'Minimize' : 'Maximize'}
            onClick={this.handleToggleMaximized}
          />
        </div>
      )

      return (
        <div
          className={`maximizable maximizable_${className || ''}`}
        >
          {maximized ? (
            <DialogContainer
              modal
              onMaskClick={ this.handleToggleMaximized }
            >
              <div className={`global_dialog modal_dialog maximizable_dialog`}>
                {_children}
              </div>
            </DialogContainer>
          ) : _children}
        </div>
      )
    }
  }
}

export default MaximizableWrapper
